import styled from 'styled-components';
import { ColumnStyled as KanbanColumnStyled } from '../../styles';

export const SkeletonWrapper = styled.div`
  display: flex;
  gap: 1.5rem;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 1rem;
  width: 100%;
  height: calc(100vh - 186px);
  align-items: flex-start;
`;

export const SkeletonColumn = styled(KanbanColumnStyled)`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border: 1.5px solid ${props => props.theme.colors.cardBorder};
`;
